import React from 'react';
import { Wrapper, Container, Header, Body, Title, BtnClose } from './styles';
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SiteNew from 'features/SiteNew';

const ModalSiteNew = ({ handleClose, handleSave }) => {

  const closeBox = () => {
    handleClose();
  }

  const handleSaveSite = (siteInfo) => {
    handleSave(siteInfo);
    handleClose();
  }
  return (
    <Wrapper>
      <Container>
        <Header>
          <Title>{"現場登録"}</Title>
          <BtnClose onClick={() => { closeBox() }}><FontAwesomeIcon icon={faXmark} /></BtnClose>
        </Header>
        <Body >
          <SiteNew hiddenHeader handleSaveSite={handleSaveSite} />
        </Body>
      </Container>
    </Wrapper>
  )
}



export default ModalSiteNew
